import React from 'react';
import { useLocation } from 'react-router-dom';
import { Header } from 'src/design/organisms/Header';
import { RoleForm } from 'src/routes/Settings/Roles/components/RoleForm';

export const CreateRole: React.FC = () => {
  const { state } = useLocation();
  const listPath = (state as { from?: string })?.from ?? '/settings/roles';

  return (
    <>
      <Header
        title="Create Role"
        helpText="Roles determine access to features through the use of pre-defined scopes. Scopes control what resources a user with a role can read, write, and/or manage."
        breadcrumbProps={{
          items: [
            { text: 'Settings', href: '/settings' },
            { text: 'Roles', href: listPath },
            { text: 'Create Role' },
          ],
        }}
      />
      <RoleForm listPath={listPath} />
    </>
  );
};
